import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=51fc7dc8&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fc7dc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51fc7dc8')) {
      api.createRecord('51fc7dc8', component.options)
    } else {
      api.reload('51fc7dc8', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=51fc7dc8&scoped=true&", function () {
      api.rerender('51fc7dc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2geDea4EA5jrk/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports